module.exports = __webpack_public_path__ + "static/media/19154-[Convertido].105cfbf7.jpg";